import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { ChevronLeft } from 'lucide-react';

import { useAuthStore } from '@/store/auth.store';
import { getClientMe, updateProfile } from '@/services/client';

export default function ProfileEditName() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const token = useAuthStore((s) => s.accessToken);
  const setUser = useAuthStore((s) => s.setUser);

  const { data: me } = useQuery({
    queryKey: ['client/me'],
    queryFn: getClientMe,
    enabled: !!token,
  });

  const [name, setName] = useState('');

  useEffect(() => {
    if (me?.user) setName(me.user.name ?? '');
  }, [me]);

  const saveMut = useMutation({
    mutationFn: () => updateProfile({ name: name.trim() || null }),
    onSuccess: (u) => {
      if (me?.user) {
        setUser({ ...me.user, name: u.name });
      }
      qc.invalidateQueries({ queryKey: ['client/me'] });
      toast.success('Имя сохранено');
      navigate('/profile');
    },
    onError: () => toast.error('Не удалось сохранить'),
  });

  if (!token) {
    navigate('/login', { replace: true });
    return null;
  }

  return (
    <div className="pt-4 pb-8">
      <div className="px-4 mb-4 flex items-center gap-2">
        <Link to="/profile" className="btn-ghost -ml-2 px-2">
          <ChevronLeft size={20} />
        </Link>
        <h1 className="text-2xl font-semibold">Имя</h1>
      </div>

      <div className="px-4 space-y-3">
        <div className="card p-4">
          <label className="label text-xs mb-1 block text-slate-500">Как вас называть</label>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Имя"
            autoFocus
            maxLength={60}
          />
        </div>
        <button
          className="btn-primary w-full"
          onClick={() => saveMut.mutate()}
          disabled={saveMut.isPending}
        >
          {saveMut.isPending ? 'Сохраняем…' : 'Сохранить'}
        </button>
      </div>
    </div>
  );
}
